module.exports = __webpack_public_path__ + "img/中国农业银行.0fad243f.png";